var headerMenu = (() => {
  var setViewAllButtons = () => {
    document.querySelectorAll('[js-mobile-menu-view-all]').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const container = element.closest('.menu-drawer__inner-submenu');
        if (!container) return;
        const backButton = container.querySelector('.menu-drawer__close-button');
        if (backButton) backButton.click();
      });
    });
  }
  var initialize = () => {
    setViewAllButtons();
  }
  return {
    init: initialize
  }
})();

var cartItemImageModal = (() => {
  var showModal = (modal) => {
    modal.classList.add('active');
    modal.style.visibility = 'visible';
  }
  var hideModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('active');
    setTimeout(() => {
      modal.style.visibility = 'hidden';
    }, 200);
  }
  var initialize = () => {
    document.querySelectorAll('[js-cart-item-image-modal] [js-close]').forEach(element => {
      element.addEventListener('click', () => {
        hideModal(element.closest('[js-cart-item-image-modal]'));
      });
    });
  }
  return {
    init: initialize,
    show: showModal
  }
})();

var cartItem = (() => {
  var showCartItemImageModal = (cartItemImage) => {
    if (!cartItemImage.closest('td')) return;
    const cartItemImageModalElement = cartItemImage.closest('td').querySelector('[js-cart-item-image-modal]');
    if (cartItemImageModalElement)
      cartItemImageModal.show(cartItemImageModalElement);
  }
  var initialize = () => {
    cartItemImageModal.init();
    var cartItemImages = document.querySelectorAll('reloaded-tib-image');
    cartItemImages.forEach(cartItemImage => {
      cartItemImage.addEventListener('click', () => {
        showCartItemImageModal(cartItemImage);
      });
    });
  }
  return {
    init: initialize
  }
})();

var anchorToProductSection = (() => {
  var goToProductSection = () => {
    const targetSection = document.querySelector('.shopify-section.product-section');
    let scrollTop = 0;
    if (window.innerWidth >= 750) {
      scrollTop = targetSection.getBoundingClientRect().top + window.scrollY - 200;
    } else {
      scrollTop = targetSection.getBoundingClientRect().top + window.scrollY;
    }
    window.scrollTo(0, scrollTop);
  }
  var initialize = () => {
    document.querySelectorAll('[js-anchor-to-product-section]').forEach(element => {
      element.addEventListener('click', (e) => {
        if (document.body.classList.contains('landing-product-ab-test-b')) {
          e.preventDefault();
          goToProductSection();
        }
      });
    });
  }
  return {
    init: initialize
  }
})();

var addClassAfterDom = () => {
  document.querySelectorAll('[js-add-class-after-dom]').forEach(element => {
    const classList = element.getAttribute('js-add-class-after-dom').split(' ');
    classList.forEach(className => {
      element.classList.add(className);
    });
  });
}

var pdpFlowApp = (() => {
  var isSelectedField = (element) => {
    if (!element) return false;

    if (element.querySelector('.active')) return true;

    if (element.classList.contains('sr-only')) return true;

    if (
      element.querySelector('.tee-custom-select__current:not(.tee-custom-select__placeholder)')
    ) return true;

    if (
      element.querySelector('.tee-colorpicker')
    ) return true;

    if (
      element.querySelector('input') && 
      element.querySelector('input').type === 'text' &&
      element.querySelector('input').value !== ''
    ) return true;

    if (
      element.querySelector('input') && 
      element.querySelector('input').type === 'number' &&
      element.querySelector('input').value !== ''
    ) return true;

    if (
      element.querySelector('textarea') && 
      element.querySelector('textarea').value !== ''
    ) return true;

    if (
      element.querySelector('input') && 
      element.querySelector('input').type === 'file' &&
      element.querySelector('.tee-photo-uploaded .tee-photo-image')
    ) return true;

    if (
      element.querySelector('input') && 
      element.querySelector('input').type === 'datetime-local' &&
      element.querySelector('input').value !== ''
    ) return true;

    if (
      element.querySelector('input') &&
      element.querySelector('input').type === 'checkbox'
    ) return true;

    if (
      element.querySelector('select') &&
      element.querySelector('select').value !== 'null'
    )
      return true;

    if (
      element.querySelector('.tee-scrabble-wrapper') &&
      element.querySelector('.tee-scrabble-wrapper>.tee-scrabble__words-item')
    )
      return true;

    return false;
  }
  var isDisplayed = (element) => {
    return window.getComputedStyle(element).display !== 'none' &&
          window.getComputedStyle(element).visibility !== 'hidden' &&
          element.offsetParent !== null;
  }
  var updateCurrentFocus = (container) => {
    let flag = false;
    container.querySelectorAll(':scope>.tee-field').forEach(fieldElement => {
      fieldElement.classList.remove('current-step');
      if (!isSelectedField(fieldElement) && !flag) {
        fieldElement.classList.add('current-step');
        flag = true;
      }
    });
    if (flag === false || !isDisplayed(container)) {
      container.classList.add('step-done');
      const wrapper = container.closest('.tee-customization-wrapper');
      if (wrapper && wrapper.querySelector('#teeAtcButton span')) {
        wrapper.querySelector('#teeAtcButton span').innerText = 'In den Warenkorb';
      }
    } else {
      container.classList.remove('step-done');
      const wrapper = container.closest('.tee-customization-wrapper');
      if (wrapper && wrapper.querySelector('#teeAtcButton span')) {
        wrapper.querySelector('#teeAtcButton span').innerText = 'Wähle deine Konfiguration';
      }
    }
  }
  var initialize = () => {
    if (!document.body.hasAttribute('pdp-flow-ab-test')) return;
    document.addEventListener('tee-customization-form:add-step', () => {
      document.querySelectorAll('.tee-customization-form').forEach(element => {
        updateCurrentFocus(element);
      });
    });
  }
  return {
    init: initialize
  }
})();

var app = (() => {
  var initialize = () => {
    headerMenu.init();
    cartItem.init();
    anchorToProductSection.init();
    pdpFlowApp.init();
    addClassAfterDom();
  }
  return {
    init: initialize
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  app.init();
  if (document.body.hasAttribute('banner-ab-test')) {
    localStorage.setItem('banner_ab_test__product_page', 'A');
  }
  if (document.body.hasAttribute('banner-event-ab-test')) {
    localStorage.setItem('banner_ab_test__product_page', 'B');
  }

  if (localStorage.getItem('banner_ab_test__product_page') === 'A' && document.body.classList.contains('template-type-product')) {
    document.body.setAttribute('banner-ab-test', true);
  }
  if (localStorage.getItem('banner_ab_test__product_page') === 'B' && document.body.classList.contains('template-type-product')) {
    document.body.setAttribute('banner-event-ab-test', true);
  }
});

document.addEventListener('cart-drawer:open', () => {
  cartItem.init()
});

document.addEventListener('cart:items-rerendered', () => {
  cartItem.init();
});

var updateMobileHeaderSearchBar = () => {
  if(window.innerWidth <= 750 && document.body.classList.contains('new-builder-design')) {
    const header = document.querySelector('header');
    if (!header) return;
    if (window.scrollY > 0) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
}

window.addEventListener('scroll', () => {
  updateMobileHeaderSearchBar();
});

function initializeLambdaUpload() {
  window.lambdaEndpoint = 'https://pkkku2qrh6.execute-api.eu-central-1.amazonaws.com/dev/petprinted-api-generate-digital-pdf';
  window.uploadedImages = new Set();
  window.finalUploadedImages = new Set();
  window.originalImageUploadStarted = false;
  window.originalImageUploaded = false;
  window.detectedImages = new Set();
}

function resetUploadTracking() {
  window.uploadedImages.clear();
  window.finalUploadedImages.clear();
  window.originalImageUploadStarted = false;
  window.originalImageUploaded = false;
  window.detectedImages.clear();
}

async function getPresignedUrl(fileName, fileType, folderPath) {
  try {
    const response = await fetch(window.lambdaEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileName: fileName,
        fileType: fileType,
        folderPath: folderPath
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.uploadURL;
  } catch (error) {
    throw error;
  }
}

window.imagesToUpload = [];

async function bufferImageForUpload(imageElement, folderPath = 'originial-image/') {
  const isFinalImage = folderPath === 'cropped-image/';
  const trackingSet = isFinalImage ? window.finalUploadedImages : window.uploadedImages;

  if (imageElement.dataset.s3Buffered === 'true') {
    return;
  }

  if (trackingSet && trackingSet.has(imageElement.src)) {
    imageElement.dataset.s3Buffered = 'true';
    return;
  }

  if (!isFinalImage && window.originalImageUploaded) {
    imageElement.dataset.s3Buffered = 'true';
    return;
  }

  imageElement.dataset.s3Buffered = 'true';

  try {
    const response = await fetch(imageElement.src);
    const blob = await response.blob();

    if (blob.size < 2000) {
      return;
    }

    window.imagesToUpload.push({
      blob,
      src: imageElement.src,
      folderPath,
      isFinalImage
    });

    if (trackingSet) {
      trackingSet.add(imageElement.src);
    }
    if (!isFinalImage) {
      window.originalImageUploaded = true;
    }
  } catch (error) {
  }
}

async function uploadBufferedImagesToS3() {
  if (!window.imagesToUpload || window.imagesToUpload.length === 0) {
    return;
  }
  for (const img of window.imagesToUpload) {
    try {
      const fileName = 'teeinblue-upload-' + Date.now() + '-' + Math.floor(Math.random()*100000) + '.jpg';
      const uploadURL = await getPresignedUrl(fileName, 'image/jpeg', img.folderPath);
      const uploadResponse = await fetch(uploadURL, {
        method: 'PUT',
        body: img.blob,
        headers: { 'Content-Type': 'image/jpeg' }
      });
      if (!uploadResponse.ok) {
        throw new Error(`Upload failed with status: ${uploadResponse.status}`);
      }
    } catch (error) {
    }
  }
  window.imagesToUpload = [];
}

function monitorOrderCompletion() {
  if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.order_id) {
    if (window.imagesToUpload && window.imagesToUpload.length > 0) {
      uploadBufferedImagesToS3();
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initializeLambdaUpload();
  
  function monitorTeeinBlueProcess() {
    function monitorEditingTools() {
      const editingSelectors = [
        '.tee-cropper-zoom',
        '.tee-ip-toolbar',
        '.tee-dialog-image-cropper',
        '.tee-photo-draggable',
        '.drr-stick',
        '.tee-btn[data-action="crop"]',
        '.tee-btn[data-action="rotate"]',
        '.tee-btn[data-action="zoom"]'
      ];
      
      editingSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (!element.dataset.editingMonitored) {
            element.dataset.editingMonitored = 'true';
            
            function findAndLogImage() {
              const imageSelectors = [
                '.vue-preview__image',
                '.tee-photo-draggable img',
                '.drr img', 
                '.tee-cropper-zoom img',
                '.tee-dialog-image-cropper img',
                '#tee-gallery img',
                'img[src*="teeinblue"]',
                'img[src*="cdn.teeinblue"]',
                'img[src*="customizations"]'
              ];
              
              let foundImage = null;
              
              for (let selector of imageSelectors) {
                const images = document.querySelectorAll(selector);
                for (let img of images) {
                  if (img.src && img.src !== '' && img.src !== window.location.href) {
                    foundImage = img;
                    break;
                  }
                }
                if (foundImage) break;
              }
              
              if (foundImage) {
                if (foundImage.complete && foundImage.naturalWidth > 0) {
                } else {
                  foundImage.onload = function() {
                  };
                }
                
                const parentElement = foundImage.closest('.tee-photo-draggable, .drr, .tee-cropper-zoom, .vue-preview');
                
                bufferImageForUpload(foundImage)
                  .then(data => {
                  })
                  .catch(error => {
                    foundImage.dataset.s3Uploaded = 'false';
                  });
              } else {
                setTimeout(findAndLogImage, 500);
              }
            }
            
            setTimeout(findAndLogImage, 100);
            setTimeout(findAndLogImage, 1000);
            
            const removalObserver = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                  mutation.removedNodes.forEach(function(node) {
                    if (node === element || (node.nodeType === 1 && node.contains(element))) {
                      resetUploadTracking();
                      
                      function findAndLogFinalImage() {
                        const finalImageSelectors = [
                          '.tee-photo-label img',
                          '.tee-photo-uploaded img',
                          '.tee-photo-label .tee-photo-uploaded img',
                          '.tee-photo-uploaded .tee-photo-label img',
                          '.tee-preview img',
                          '.tee-product-preview img',
                          '.vue-preview__image',
                          '.tee-photo-draggable img',
                          '.drr img', 
                          '#tee-gallery img',
                          'img[src*="teeinblue"]',
                          'img[src*="cdn.teeinblue"]',
                          'img[src*="customizations"]',
                          'img[src*="processed"]',
                          'img[src*="final"]',
                          'img[src*="crop"]',
                          'img[src*="edit"]',
                          'img[src*="result"]',
                          'img[src*="output"]'
                        ];
                        
                        let foundFinalImage = null;
                        
                        let originalImageUrl = null;
                        if (window.uploadedImages && window.uploadedImages.size > 0) {
                          originalImageUrl = Array.from(window.uploadedImages)[0];
                        }
                        
                        for (let selector of finalImageSelectors) {
                          const images = document.querySelectorAll(selector);
                          for (let img of images) {
                            if (img.src && 
                                img.src !== '' && 
                                img.src !== window.location.href &&
                                img.src !== originalImageUrl &&
                                !img.src.includes('loading.svg') &&
                                !img.src.includes('placeholder') &&
                                img.naturalWidth > 100 &&
                                img.naturalHeight > 100) {
                              foundFinalImage = img;
                              break;
                            }
                          }
                          if (foundFinalImage) break;
                        }
                        
                        if (foundFinalImage) {
                          bufferImageForUpload(foundFinalImage, 'cropped-image/')
                            .then(data => {
                            })
                            .catch(error => {
                            });
                        } else {
                          document.querySelectorAll('img').forEach((img, index) => {
                            if (img.src && img.src !== '' && img.src !== window.location.href) {
                            }
                          });
                          setTimeout(findAndLogFinalImage, 500);
                        }
                      }
                      
                      setTimeout(findAndLogFinalImage, 500);
                      setTimeout(findAndLogFinalImage, 1500);
                      setTimeout(findAndLogFinalImage, 3000);
                      setTimeout(findAndLogFinalImage, 5000);
                      
                      const allImages = document.querySelectorAll('img');
                      allImages.forEach((img, index) => {
                        if (img.src && img.src !== '' && img.src !== window.location.href) {
                        }
                      });
                      
                      const imageObserver = new MutationObserver(function(mutations) {
                        mutations.forEach(function(mutation) {
                          if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                              if (node.nodeType === 1 && node.tagName === 'IMG') {
                                if (node.src && 
                                    node.src !== '' && 
                                    node.src !== window.location.href &&
                                    !node.src.includes('loading.svg') &&
                                    !node.src.includes('placeholder') &&
                                    node.naturalWidth > 100 &&
                                    node.naturalHeight > 100) {
                                }
                              }
                            });
                          }
                        });
                      });
                      
                      imageObserver.observe(document.body, {
                        childList: true,
                        subtree: true
                      });
                      
                      setTimeout(() => {
                        imageObserver.disconnect();
                      }, 10000);
                      
                      removalObserver.disconnect();
                    }
                  });
                }
              });
            });
            
            removalObserver.observe(document.body, {
              childList: true,
              subtree: true
            });
          }
        });
      });
    }
    
    monitorEditingTools();
  }
  
  let tries = 0;
  const maxTries = 20;
  const interval = setInterval(function() {
    monitorTeeinBlueProcess();
    tries++;
    if (tries >= maxTries) {
      clearInterval(interval);
    }
  }, 500);


  const productInfoWrapper = document.querySelector('.product__info-wrapper');
  if(productInfoWrapper) {
    addElementOnAppearing(productInfoWrapper, '.tee-option--size .tee-row .tee-field','#product_size_recommendation','append');
    addElementOnAppearing(productInfoWrapper, '.tee-form-atc-wrapper','#buy-one-get-one','prepend');
    addElementOnAppearing(productInfoWrapper, '.tee-form-atc-wrapper','#profi-datencheck','prepend');
  }
  const gallery = document.querySelector('.product__media-wrapper');
  if(gallery){
    addElementOnAppearing(gallery,'.tee-gallery','#made-in-germany-badge','prepend');
  }
});

function addElementOnAppearing(parent, targetElementSelector, elementToAddSelector, where) {
  const elementToAdd = document.querySelector(elementToAddSelector);
  if(!elementToAdd) return;
  const observer = new MutationObserver((mutations)=>{
    const targetElement = document.querySelector(targetElementSelector);
    if(targetElement && elementToAdd) {
      if(where == 'append') {
        targetElement.appendChild(elementToAdd.content.cloneNode(true));
      }
      if(where == 'prepend') {
        targetElement.prepend(elementToAdd.content.cloneNode(true));
      }
      observer.disconnect();      
    }
  })

  observer.observe(parent, {
    childList: true,
    subtree: true
  });
}

function monitorAddToCartButton() {
  function findButton() {
    const btns = Array.from(document.querySelectorAll('button, input[type="button"], input[type="submit"]'));
    for (const btn of btns) {
      if (btn.innerText && btn.innerText.trim().toLowerCase().includes('in den warenkorb')) {
        return btn;
      }
    }
    return document.querySelector('[data-action="add-to-cart"], [data-action="add_to_cart"]');
  }
  
  function attachListener() {
    const btn = findButton();
    if (btn && !btn.dataset.s3ListenerAttached) {
      btn.addEventListener('click', function() {
        uploadBufferedImagesToS3();
      });
      btn.dataset.s3ListenerAttached = 'true';
      return true;
    }
    return false;
  }
  
  if (attachListener()) {
    return;
  }
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            const buttons = node.tagName === 'BUTTON' ? [node] : node.querySelectorAll ? node.querySelectorAll('button, input[type="button"], input[type="submit"]') : [];
            if (buttons.length > 0) {
              if (attachListener()) {
                observer.disconnect();
              }
            }
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

}

monitorAddToCartButton();

function fixSalePrices() {
  // Sale-Preise
  document.querySelectorAll('.ProductCard .price--on-sale .price__sale').forEach(el => {
    el.style.removeProperty('display');
    el.style.setProperty('display', 'flex', 'important');
  });
  document.querySelectorAll('.ProductCard .price--on-sale .price__regular').forEach(el => {
    el.style.removeProperty('display');
    el.style.setProperty('display', 'flex', 'important');
  });
  // Normale Preise (kein Sale)
  document.querySelectorAll('.ProductCard .price:not(.price--on-sale) .price__regular').forEach(el => {
    el.style.removeProperty('display');
    el.style.setProperty('display', 'flex', 'important');
  });
}

document.addEventListener('DOMContentLoaded', fixSalePrices);
setTimeout(fixSalePrices, 500);
setTimeout(fixSalePrices, 1500);

const observer = new MutationObserver(fixSalePrices);
observer.observe(document.body, { childList: true, subtree: true });